// extracted by mini-css-extract-plugin
module.exports = {"customPopconfirm":"CustomPopconfirm_customPopconfirm__2KWiq"};